<div
  class="eiq-text-editor__container"
  [ngClass]="{ focused: focused$(), invalid: !focused$() && editorCtrl$().invalid && editorCtrl$().touched, border: showBorder() }"
>
  @if (!hideToolbar()) {
    <div class="eiq-text-editor__toolbar-container">
      <div class="eiq-text-editor__toolbar" [ngClass]="'eiq-text-editor__toolbar_' + id()"></div>
    </div>
  }

  <ckeditor
    [id]="'ckeditor' + id()"
    [config]="config"
    [editor]="editor"
    [formControl]="editorCtrl$()"
    [ngClass]="appearance()"
    [attr.data-testid]="testId() ? testId() + '-text-editor' : null"
    (ready)="onReady($event)"
  ></ckeditor>
</div>
@if (editorCtrl$().invalid && editorCtrl$().touched) {
  <div class="eiq-text-editor__error">
    <eiq-validation-text [formCtrl]="editorCtrl$()"></eiq-validation-text>
  </div>
}
